module.exports = "/images/ny-blck-5.jpg";